import { render } from "./uploadPreuve.vue?vue&type=template&id=ba52f622&scoped=true"
import script from "./uploadPreuve.vue?vue&type=script&lang=js"
export * from "./uploadPreuve.vue?vue&type=script&lang=js"

import "./uploadPreuve.vue?vue&type=style&index=0&id=ba52f622&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba52f622"]])

export default __exports__